import ArrowRight from "../icons/ArrowRight";
import OutboundLink from "../OutboundLink";
import { FrameworkCarousel } from "./FrameworkCarousel";

export const FrameworkPreview = () => (
  <div className="mx-auto max-w-[548px] px-4 text-center medium:max-w-[1156px] medium:px-6">
    <h2 className="mb-8 text-4xl leading-tight medium:mb-14 medium:text-[64px] medium:tracking-[-1px]">
      XQ Competency Framework (v2.2)
    </h2>
    <p className="mb-8 font-roobert text-xl leading-none text-dark-color medium:mb-12 medium:text-2xl medium:font-medium">
      Transform your classroom, school, or system
    </p>
    <p className="mb-8 leading-5 text-gray-text medium:mb-16 medium:text-xl medium:leading-[26px]">
      The XQ Competency Framework paves a path to student success in college,
      career, and beyond. As part of a new architecture for education, the XQ
      Competencies open up opportunities for how we design learning experiences,
      assess student progress, and certify student learning.
    </p>
    <FrameworkCarousel />
    <OutboundLink
      href=" https://xqcompetencies.xqsuperschool.org/about"
      className="mt-8 inline-flex h-10 items-center gap-1 rounded-full bg-BG-60 py-3.5 pl-4 pr-3 font-semibold text-white hover:bg-BG-70 active:bg-BG-80 medium:mt-16 medium:h-16 medium:pl-6 medium:pr-4"
    >
      Learn more about XQ Competencies
      <ArrowRight fill="#FFFFFF" className="-rotate-45" />
    </OutboundLink>
  </div>
);
